import axios from 'axios';
import { Professor } from 'src/models';

import { BASE_URL } from './config';
// Updated endpoint from '/api/materias' to '/api/subjects'
const ENDPOINT = '/api/subjects';

export function getSubjects(employeeId: string) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  return apiClient.get<Professor>(`${ENDPOINT}/${employeeId}`);
}
